/**
 * NotificationBell — polls unread inbox count every 30s.
 * Renders inline within the sidebar header next to the logo.
 * Click → navigate to /inbox.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const fetchCount = async () => {
    try {
      const r = await axios.get(`${API}/inbox/unread-count`, { withCredentials: true });
      setCount(r.data?.total || 0);
    } catch {
      // Silently ignore — avoid spamming user if backend is down
    }
  };

  useEffect(() => {
    fetchCount();
    const id = setInterval(fetchCount, 30000); // 30s polling
    return () => clearInterval(id);
  }, []);

  return (
    <button
      onClick={() => navigate("/inbox")}
      className="relative p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
      data-testid="notification-bell"
      title={count > 0 ? `${count} neue Nachrichten` : "Social-Inbox"}
    >
      <Bell className="w-4 h-4 text-slate-500 hover:text-slate-900" />
      {count > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-[#2563EB] text-white text-[9px] font-bold leading-none"
          data-testid="notification-bell-count"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
